import React, { Component } from 'react'
import './index.css'
import { Layout, Affix, Button, Icon, Anchor } from 'antd';
import { withTranslation } from 'react-i18next';
const { Content } = Layout;
class PolicyUserTW extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // top: 85,
            // bottom: 10,
            // offsetTop: 80
        };
    }
    render() {
        const { t } = this.props
        return (
            <Content className="q-content-wrapper">
                <div className="q-main " style={{ padding: '65px 0 20px 0px' }}>
                    <Content className="q-detail-content q-policy" >
                    <div className="right-content" id="soft-introduce">
                        <h2>{t('policyUserTitle')}</h2>
                        <div className="right-content-box" >
                            <p>{t('policyUserContent')}</p>
                            <p>{t('policyUserContent1')}</p>
                            <p>{t('policyUserContent2')}</p>
                            <p>{t('policyUserContent3')}</p>
                            <p>{t('policyUserContent4')}</p>
                            <p>{t('policyUserContent5')}</p>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyUserItem01')}</h4>
                            <ul>
                                <p>{t('policyUserItem01_1')}</p>
                                <p>{t('policyUserItem01_2')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >                            
                            <h4>{t('policyUserItem02')}</h4>
                            <ul>
                                <p>{t('policyUserItem02_1')}</p>
                                <p>{t('policyUserItem02_2')}</p>
                                <p>{t('policyUserItem02_3')}</p>
                                <p>{t('policyUserItem02_4')}</p>
                                <ul>
                                    <p>{t('policyUserItem02_41')}</p>
                                    <p>{t('policyUserItem02_42')}</p>
                                    <p>{t('policyUserItem02_43')}</p>
                                    <p>{t('policyUserItem02_44')}</p>
                                    <p>{t('policyUserItem02_45')}</p>
                                    <p>{t('policyUserItem02_46')}</p>
                                </ul>
                                <p>{t('policyUserItem02_5')}</p>
                                <p>{t('policyUserItem02_6')}</p>
                                <ul>
                                    <p>{t('policyUserItem02_61')}</p>
                                    <p>{t('policyUserItem02_62')}</p>
                                    <p>{t('policyUserItem02_63')}</p>
                                    <p>{t('policyUserItem02_64')}</p>
                                </ul>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyUserItem03')}</h4>
                            <ul>
                                <p>{t('policyUserItem03_1')}</p>
                                <ul>
                                    <p>{t('policyUserItem03_11')}</p>
                                </ul>
                                <p>{t('policyUserItem03_2')}</p>
                                <ul>
                                    <p>{t('policyUserItem03_21')}</p>
                                </ul>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyUserItem04')}</h4>
                            <ul>
                                <p>{t('policyUserItem04_1')}</p>
                                <p>{t('policyUserItem04_2')}</p>
                                <ul>
                                    <p>{t('policyUserItem04_21')}</p>
                                    <p>{t('policyUserItem04_22')}</p>
                                </ul>
                                <p>{t('policyUserItem04_3')}</p>
                                <ul>
                                    <p>{t('policyUserItem04_31')}</p>
                                    <p>{t('policyUserItem04_32')}</p>
                                    <p>{t('policyUserItem04_33')}</p>
                                    <p>{t('policyUserItem04_34')}</p>
                                    <ul>
                                        <p>{t('policyUserItem04_341')}</p>
                                        <p>{t('policyUserItem04_342')}</p>
                                    </ul>
                                </ul>
                                <p>{t('policyUserItem04_4')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyUserItem05')}</h4>
                            <ul>
                                <p>{t('policyUserItem05_1')}</p>
                                <ul>
                                    <p>{t('policyUserItem05_11')}</p>
                                </ul>
                                <p>{t('policyUserItem05_2')}</p>
                                <ul>
                                    <p>{t('policyUserItem05_21')}</p>
                                    <p>{t('policyUserItem05_22')}</p>
                                </ul>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyUserItem06')}</h4>
                            <ul>
                                <p>{t('policyUserItem06_1')}</p>
                                <ul>
                                    <p>{t('policyUserItem06_11')}</p>
                                </ul>
                                <p>{t('policyUserItem06_2')}</p>
                                <ul>
                                    <p>{t('policyUserItem06_21')}</p>
                                    <p>{t('policyUserItem06_22')}</p>
                                    <p>{t('policyUserItem06_23')}</p>
                                    <p>{t('policyUserItem06_24')}</p>
                                    <p>{t('policyUserItem06_25')}</p>
                                    <p>{t('policyUserItem06_26')}</p>
                                    <p>{t('policyUserItem06_27')}</p>
                                    <p>{t('policyUserItem06_28')}</p>
                                    <p>{t('policyUserItem06_29')}</p>
                                </ul>
                                <p>{t('policyUserItem06_3')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyUserItem07')}</h4>
                            <ul>
                            <p>{t('policyUserItem07_1')}</p>
                            <p>{t('policyUserItem07_2')}</p>
                            <ul> 
                                <p>{t('policyUserItem07_21')}</p>
                                <p>{t('policyUserItem07_22')}</p>
                                <p>{t('policyUserItem07_23')}</p>
                                <p>{t('policyUserItem07_24')}</p>
                                <p>{t('policyUserItem07_25')}</p>
                                <p>{t('policyUserItem07_26')}</p>
                                <p>{t('policyUserItem07_27')}</p>
                                <p>{t('policyUserItem07_28')}</p>
                                <p>{t('policyUserItem07_29')}</p>
                                <p>{t('policyUserItem07_210')}</p>
                            </ul>
                            <p>{t('policyUserItem07_3')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyUserItem08')}</h4>
                            <ul>
                                <p>{t('policyUserItem08_1')}</p>
                                <p>{t('policyUserItem08_2')}</p>
                                <p>{t('policyUserItem08_3')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyUserItem09')}</h4>
                            <ul>
                                <p>{t('policyUserItem09_1')}</p>
                                <p>{t('policyUserItem09_2')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyUserItem10')}</h4>
                            <ul>
                                <p>{t('policyUserItem10_1')}</p>
                                <p>{t('policyUserItem10_2')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyUserItem11')}</h4>
                            <ul>
                                <p>{t('policyUserItem11_1')}</p>
                                <p>{t('policyUserItem11_2')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyUserItem12')}</h4>
                            <ul>
                                <p>{t('policyUserItem12_1')}</p>
                                <p>{t('policyUserItem12_2')}</p>
                                <p>{t('policyUserItem12_3')}</p>
                                <p>{t('policyUserItem12_4')}</p>
                                <p>{t('policyUserItem12_5')}</p>
                                <p>{t('policyUserItem12_6')}</p>
                            </ul>
                        </div>
                    </div>
                   </Content>
                </div>
            </Content>
        )
    }
}
export default withTranslation()(PolicyUserTW)

